import { FEATURE_FLAGS } from 'src/constants/featureFlags'
import { useEffect } from 'react'
import { useFeatureFlag } from './useFeatureFlag'
import logToPostHog from 'src/helpers/logToPosthog'

export const useSendTreatmentEvent = () => {
  const { initialized } = useFeatureFlag(FEATURE_FLAGS.EXAMPLE_FLAG_NAME)
  useEffect(() => {
    if (initialized) logToPostHog('Treatments step displayed')
  }, [initialized])
}
